import { Button, Flex, Modal, Text } from '@cmpsr/components';

type ModalCancelMembershipProps = {
  isOpen: boolean;
  onCloseClick: () => void;
  onCancelClick: () => void;
  isTrialUser?: boolean;
};

export default function ModalCancelMembership({
  isOpen,
  onCloseClick,
  onCancelClick,
  isTrialUser = false,
}: ModalCancelMembershipProps) {
  const footerMessage = isTrialUser
    ? 'Your trial will end immediately and you will not be charged.'
    : 'You will maintain access to your account through the duration of your paid membership';

  return (
    <Modal isOpen={isOpen} onClose={onCloseClick} isCentered>
      <Modal.Overlay bg="background-overlay" backdropFilter="auto" />
      <Modal.Content
        bg="background-page"
        borderRadius="radii-2"
        border="1px solid"
        borderColor="ui-element-outline-default"
        width={{ base: '349px', lg: '603px' }}
        p={{ base: 'spacer-5', lg: 'spacer-10' }}
        gap="spacer-6"
      >
        <Modal.Header bg="background-page" p={0} textAlign="center">
          <Text variant="text-header-S">
            Are you sure you want to{' '}
            <Text as="span" textStyle="text-header-s-v">
              cancel your {isTrialUser ? 'trial' : 'membership'}?
            </Text>
          </Text>
        </Modal.Header>
        <Modal.Footer bg="background-page" flexDirection="column" gap="spacer-6" p={0}>
          <Flex flexDirection={{ base: 'column-reverse', lg: 'row' }} gap="spacer-4" width="100%">
            <Button variant="primary-alt" size="m" width={{ base: '100%', lg: '50%' }} onClick={onCloseClick}>
              Keep {isTrialUser ? 'trial' : 'membership'}
            </Button>
            <Button variant="destroy" size="m" width={{ base: '100%', lg: '50%' }} onClick={onCancelClick}>
              Cancel {isTrialUser ? 'trial' : 'membership'}
            </Button>
          </Flex>
          <Text variant="text-body-meta-regular" color="text-secondary" textAlign="center">
            {footerMessage}
          </Text>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
